<template>
    <VanCell center class="in-panel">
        <template #title>
            <div class="flex-row flex-y-center">
                <img :src="student.avatarUrl | resourceUrl" ref="student" class="avatar"
                     @error="handleRefAvatarError('student', student.gender)">
                <div class="text">
                    <div class="fs15px">{{student.name}}</div>
                    <div class="lh1_5em txt-gray">{{classNames}}</div>
                    <div v-if="payment">
                        <div class="lh1_5em">
                            <div>已交费 ￥{{(payment.amount || 0).toFixed(2)}}</div>
                            <div class="txt-gray">{{payment.confirmTime}}</div>
                        </div>
                    </div>
                    <div v-else>合计：￥{{total.toFixed(2)}}</div>
                </div>
            </div>
        </template>
    </VanCell>
</template>

<script>
    import RefAvatarErrorHandler from '@/mixins/RefAvatarErrorHandler';
    import Utils from '@/utils';

    export default {
        name: 'StudentOrderPayment',
        mixins: [RefAvatarErrorHandler],
        props: {
            student: {
                type: Object,
                default() {
                    return {};
                },
            },
            payment: {
                type: Object,
                default() {
                    return null;
                },
            },
            total: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            classNames() {
                if (this.student.classes.length) {
                    return Utils.string.arrayJoin(this.student.classes.slice(0, 2).map((cls) => cls.name), ' / ');
                }
                return '';
            },
        },
    };
</script>

<style scoped lang="less">
.avatar {
    width: 15vw;
    height: 15vw;
    border-radius: 50%;
    background-color: #eeffee;
    border: 1px solid #f1f6f1;
    display: block;
    margin-right: 0.8rem;
}
.text {
    width: calc(100vw - 72px - 15vw - 0.8rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
